// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Right-side edit drawer ===== */
.edit-drawer-paper.MuiDrawer-paper {
  width: min(620px, 100vw);
  max-width: 100vw;
  height: 100%;
  max-height: none;
  box-sizing: border-box;
  overflow: hidden;
  border: 0;
  border-left: 1px solid #e2e8f0;
  border-radius: 22px 0 0 22px;
  background: #fff;
  box-shadow: -20px 0 64px rgba(15, 23, 42, 0.18);
}

.edit-modal {
  background: #fff;
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0;
  position: relative;
}

.edit-modal-header {
  flex: 0 0 auto;
  padding: 24px 64px 20px 28px;
  border-bottom: 1px solid #e2e8f0;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.edit-title {
  margin: 0;
  font-size: calc(20px + var(--kds-font-delta, 0px));
  font-weight: 650;
  color: #0f172a;
  letter-spacing: -0.015em;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.close-btn {
  position: absolute;
  right: 16px;
  top: 16px;
  background: transparent;
  border: none;
  border-radius: 4px;
  opacity: 0.7;
  cursor: pointer;
  transition: opacity 0.2s ease;
  color: #64748b;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
}
.close-btn:hover {
  opacity: 1;
  background: #f1f5f9;
}
.close-btn svg {
  width: 16px;
  height: 16px;
}

.edit-content {
  padding: 24px 28px 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.edit-drawer-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding-bottom: 22px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.96);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* ===== Items List ===== */
.edit-items-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.edit-item-container {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.edit-item-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-radius: 16px;
  border: 1px solid #f1f5f9;
  background-color: rgba(248, 250, 252, 0.7);
  padding: 16px;
}

/* ===== Item Layout ===== */
.edit-item-line {
  display: flex;
  min-width: 0;
  flex: 1;
  align-items: center;
  gap: 12px;
}

.custom-checkbox {
  display: grid;
  place-content: center;
  flex-shrink: 0;
  border: 1px solid #cbd5e1;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  height: 20px;
  width: 20px;
  border-radius: 5px;
  background: white;
  cursor: pointer;
  padding: 0;
  color: transparent;
  transition: all 0.2s;
}

.custom-checkbox[aria-checked="true"] {
  border-color: #2a71ff;
  background-color: #2a71ff;
  color: white;
}

.custom-checkbox svg {
  height: 16px;
  width: 16px;
  pointer-events: none;
}

.edit-item-label-container {
  min-width: 0;
}

.edit-item-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: calc(16px + var(--kds-font-delta, 0px));
  font-weight: 500;
  color: #1e293b;
}

.edit-item-name-complimentary {
  background-color: #eff6ff;
  color: #2a71ff;
  border-radius: 50px;
  padding: 4px 8px;
  font-size: calc(10px + var(--kds-font-delta, 0px));
  font-weight: 600;
  margin-top: 4px;
}

/* ===== Quantity Buttons ===== */
.edit-item-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.qty-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  font-size: calc(14px + var(--kds-font-delta, 0px));
  font-weight: 500;
  transition: all 0.2s ease;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  height: 36px;
  width: 36px;
  border-radius: 10px;
  background-color: #ffffff;
  color: #475569;
  cursor: pointer;
  padding: 0;
}

.qty-btn:hover:not(:disabled) {
  background-color: #f8fafc;
}

.qty-btn:active:not(:disabled) {
  box-shadow: none;
}

.qty-btn:disabled {
  pointer-events: none;
  opacity: 0.5;
}

.qty-btn svg {
  width: 16px;
  height: 16px;
  pointer-events: none;
}

.qty-display {
  width: 24px;
  text-align: center;
  font-size: calc(16px + var(--kds-font-delta, 0px));
  font-weight: 600;
  color: #0f172a;
}

.original-qty {
  text-decoration: line-through;
  color: #94a3b8;
  font-size: calc(13px + var(--kds-font-delta, 0px));
  margin-left: 6px;
  font-weight: 400;
}

/* ===== Notes and Addons ===== */
.edit-item-note {
  background: #ffeaea;
  color: #b60000;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: calc(13px + var(--kds-font-delta, 0px));
  display: flex;
  align-items: center;
  margin: 0 0 0 44px;
}

.note-dot {
  width: 6px;
  height: 6px;
  background: #ff3b30;
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
}

.edit-addons-container {
  margin: 0 0 0 44px;
  color: #64748b;
  font-size: calc(13px + var(--kds-font-delta, 0px));
}

.edit-item-addon {
  color: #64748b;
  font-size: calc(13px + var(--kds-font-delta, 0px));
}

/* ===== Remover Section (Final UI) ===== */
.remover-section {
  background: #fef3f2;
  border-radius: 8px;
  padding: 10px 14px;
  margin: 14px 28px 0;
}
.removed-item-title-logo {
  display: flex;
  gap: 6px;
}
.remover-title {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #d92d20;
  font-size: calc(14px + var(--kds-font-delta, 0px));
  font-weight: 600;
  margin-bottom: 8px;
}

.removed-item-edit {
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 4px 0;
}

.removed-info {
  color: #444;
  font-size: calc(14px + var(--kds-font-delta, 0px));
  text-decoration: line-through;
  text-decoration-thickness: 1px;
  text-decoration-color: #555;
}

.reset-link {
  border: none;
  background: transparent;
  color: #007aff;
  cursor: pointer;
  font-size: calc(14px + var(--kds-font-delta, 0px));
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: color 0.2s ease;
}

.reset-link:hover {
  color: #005ed1;
}

/* ===== Complimentary Section ===== */
.complimentary-section {
  margin-top: 18px;
  padding: 0 28px;
  margin-bottom: 10px;
}

.complimentary-label {
  display: block;
  margin-bottom: 8px;
  font-size: calc(15px + var(--kds-font-delta, 0px));
  font-weight: 600;
  color: #334155;
}

.complimentary-search-wrapper {
  position: relative;
  width: 100%;
}

.complimentary-search-icon {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  color: #94a3b8;
  pointer-events: none;
}

.complimentary-search-input {
  display: flex;
  width: 100%;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 4px 12px 4px 44px;
  height: 48px;
  font-size: calc(15px + var(--kds-font-delta, 0px));
  background-color: #ffffff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  transition:
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}

.complimentary-search-input:focus {
  outline: none;
  border-color: #cbd5e1;
  box-shadow: 0 0 0 1px #cbd5e1;
}

.complimentary-search-input::placeholder {
  color: #94a3b8;
}

.complimentary-search-input:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.search-result {
  padding: 6px 10px;
  cursor: pointer;
  font-size: calc(13px + var(--kds-font-delta, 0px));
}

.search-result:hover {
  background: #f5f5f5;
}

.complimentary-item {
  margin-top: 6px;
  font-size: calc(14px + var(--kds-font-delta, 0px));
  color: #333;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.edit-item-name-container {
  display: flex;
  align-items: center;
  gap: 6px;
}

/* ===== Footer Section ===== */
.edit-footer {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column-reverse;
  border-top: 1px solid #e2e8f0;
  padding: 16px 28px max(16px, env(safe-area-inset-bottom));
  gap: 12px;
  background: #ffffff;
}

@media (min-width: 640px) {
  .edit-footer {
    flex-direction: row;
    justify-content: flex-end;
  }
}

.edit-footer-content {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 12px;
}

@media (min-width: 768px) {
  .edit-footer-content {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
}

.edit-footer-right {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

@media (min-width: 768px) {
  .edit-footer-right {
    flex-direction: row;
    align-items: center;
  }
}

/* ===== Common Button Base ===== */
.reject-btn,
.update-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  transition: all 0.2s ease;
  min-height: 36px;
  padding: 8px 20px;
  height: 48px;
  border-radius: 20px;
  font-size: calc(16px + var(--kds-font-delta, 0px));
  font-weight: 600;
  cursor: pointer;
}

.reject-btn svg,
.update-btn svg {
  height: 16px;
  width: 16px;
  flex-shrink: 0;
}

/* ===== Reject (outlined red) ===== */
.reject-btn {
  border: 1px solid #fecdd3;
  color: #e11d48;
  background-color: transparent;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.reject-btn:hover {
  border-color: #fda4af;
  background-color: #fff1f2;
  color: #be123c;
}

/* ===== Update Changes (solid blue) ===== */
.update-btn {
  border: 1px solid transparent;
  background-color: #2a71ff;
  color: #ffffff;
}

.update-btn:hover {
  background-color: #1f63ea;
}

.update-btn:disabled {
  opacity: 0.5;
  pointer-events: none;
}

/* ===== Icon Styling ===== */
.btn-icon {
  font-size: calc(14px + var(--kds-font-delta, 0px));
  display: inline-block;
  line-height: 1;
}

/* ===== Scrollbar ===== */
.edit-drawer-body::-webkit-scrollbar {
  width: 6px;
}
.edit-drawer-body::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.15);
  border-radius: 3px;
}

@media (max-width: 600px) {
  .edit-drawer-paper.MuiDrawer-paper {
    width: 100vw;
    border-radius: 0;
  }

  .edit-modal-header {
    padding: 20px 56px 18px 20px;
  }

  .edit-content {
    padding: 18px 20px 0;
  }

  .remover-section {
    margin-left: 20px;
    margin-right: 20px;
  }

  .complimentary-section {
    padding-left: 20px;
    padding-right: 20px;
  }

  .edit-footer {
    padding-left: 20px;
    padding-right: 20px;
  }
}

/* ===== Cancellation selection and review ===== */
.edit-selection-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 0 16px;
  border-bottom: 1px solid #e8edf3;
  color: #657184;
  font-size: calc(13px + var(--kds-font-delta, 0px));
}

.edit-selection-toolbar label,
.cancellation-billing label {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  color: #334155;
  font-weight: 550;
}

.edit-selection-toolbar input,
.cancellation-review input[type="checkbox"],
.cancellation-review input[type="radio"] {
  width: 18px;
  height: 18px;
  margin: 0;
  accent-color: #2563eb;
  flex: 0 0 auto;
}

.edit-selection-toolbar label:has(input:disabled),
.cancellation-billing label.is-disabled {
  cursor: not-allowed;
  opacity: 0.58;
}

.cancellation-entry-btn,
.cancellation-confirm-btn,
.cancellation-secondary-btn {
  min-height: 42px;
  border-radius: 10px;
  padding: 10px 16px;
  font-size: calc(14px + var(--kds-font-delta, 0px));
  font-weight: 650;
  cursor: pointer;
  transition: background-color 0.16s ease, border-color 0.16s ease, opacity 0.16s ease;
}

.cancellation-entry-btn {
  flex: 0 0 auto;
  border: 1px solid #f1b3b3;
  background: #fff;
  color: #b42318;
}

.cancellation-entry-btn:hover:not(:disabled) {
  background: #fff5f4;
  border-color: #e8918c;
}

.cancellation-entry-btn:disabled,
.cancellation-confirm-btn:disabled,
.cancellation-secondary-btn:disabled {
  cursor: not-allowed;
  opacity: 0.52;
}

.cancellation-review {
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 0;
  flex-direction: column;
  background: #fff;
}

.cancellation-review-header {
  position: relative;
  flex: 0 0 auto;
  padding: 26px 64px 20px 28px;
  border-bottom: 1px solid #e5eaf0;
}

.cancellation-eyebrow {
  margin: 0 0 7px;
  color: #8a5360;
  font-size: calc(10px + var(--kds-font-delta, 0px));
  font-weight: 750;
  letter-spacing: 0.13em;
}

.cancellation-subtitle {
  margin: 7px 0 0;
  color: #687587;
  font-size: calc(14px + var(--kds-font-delta, 0px));
  line-height: 1.45;
}

.cancellation-close {
  position: absolute;
  top: 18px;
  right: 18px;
}

.cancellation-review-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 22px 28px;
}

.cancellation-scope {
  margin-bottom: 22px;
  overflow: hidden;
  border: 1px solid #e5eaf0;
  border-radius: 13px;
  background: #f8fafc;
}

.cancellation-scope-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 15px;
  color: #445165;
  font-size: calc(13px + var(--kds-font-delta, 0px));
  font-weight: 650;
}

.cancellation-scope-heading strong {
  display: grid;
  width: 26px;
  height: 26px;
  place-items: center;
  border-radius: 50%;
  background: #e9eef5;
  color: #364152;
  font-size: calc(12px + var(--kds-font-delta, 0px));
}

.cancellation-item-list {
  display: flex;
  flex-direction: column;
  gap: 1px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.cancellation-item-list li {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 11px 15px;
  border-top: 1px solid #e9edf2;
  color: #344054;
  font-size: calc(14px + var(--kds-font-delta, 0px));
}

.cancellation-item-list li strong {
  flex: 0 0 auto;
  color: #5b6676;
}

.cancellation-fieldset {
  min-width: 0;
  margin: 0 0 21px;
  padding: 0;
  border: 0;
}

.cancellation-fieldset legend {
  margin-bottom: 10px;
  color: #283548;
  font-size: calc(14px + var(--kds-font-delta, 0px));
  font-weight: 700;
}

.cancellation-fieldset legend span {
  color: #c03535;
}

.cancellation-fieldset select,
.cancellation-fieldset textarea {
  display: block;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #d8e0e9;
  border-radius: 10px;
  background: #fff;
  color: #273548;
  font: inherit;
  font-size: calc(14px + var(--kds-font-delta, 0px));
}

.cancellation-fieldset select {
  min-height: 46px;
  padding: 0 13px;
}

.cancellation-fieldset textarea {
  min-height: 82px;
  margin-top: 10px;
  padding: 12px 13px;
  resize: vertical;
}

.cancellation-fieldset select:focus,
.cancellation-fieldset textarea:focus {
  outline: 2px solid rgba(37, 99, 235, 0.2);
  border-color: #6e9beb;
}

.cancellation-choice-list {
  display: grid;
  gap: 9px;
}

.cancellation-choice-list label {
  display: flex;
  align-items: flex-start;
  gap: 11px;
  padding: 12px;
  border: 1px solid #e0e6ed;
  border-radius: 11px;
  cursor: pointer;
}

.cancellation-choice-list label:has(input:checked) {
  border-color: #8aabd9;
  background: #f4f8ff;
}

.cancellation-choice-list label > span {
  display: grid;
  gap: 3px;
  color: #334155;
  font-size: calc(13px + var(--kds-font-delta, 0px));
}

.cancellation-choice-list small {
  color: #697689;
  font-size: calc(12px + var(--kds-font-delta, 0px));
  line-height: 1.4;
}

.cancellation-note,
.cancellation-billing > p {
  margin: 8px 0 0;
  color: #6b7788;
  font-size: calc(12px + var(--kds-font-delta, 0px));
  line-height: 1.5;
}

.cancellation-note {
  padding: 11px 12px;
  border-radius: 9px;
  background: #f4f6f8;
}

.cancellation-billing {
  padding: 15px;
  border: 1px solid #e1e7ee;
  border-radius: 12px;
}

.cancellation-billing label {
  color: #344054;
  font-size: calc(14px + var(--kds-font-delta, 0px));
}

.cancellation-billing .cancellation-note {
  margin-top: 10px;
}

.cancellation-refund-option {
  margin-top: 13px;
  min-height: 38px;
  padding: 7px 12px;
  border: 1px solid #d9e0e8;
  border-radius: 8px;
  background: #f6f7f9;
  color: #687587;
  font-size: calc(13px + var(--kds-font-delta, 0px));
  font-weight: 600;
  cursor: not-allowed;
}

.cancellation-context-state {
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 18px 0;
  color: #586679;
  font-size: calc(14px + var(--kds-font-delta, 0px));
}

.cancellation-context-state .MuiCircularProgress-root {
  color: #2563eb;
}

.cancellation-context-error {
  padding: 15px;
  border: 1px solid #efc3bf;
  border-radius: 11px;
  background: #fff7f6;
  color: #963a32;
  font-size: calc(14px + var(--kds-font-delta, 0px));
  line-height: 1.5;
}

.cancellation-context-error p {
  margin: 0 0 12px;
}

.cancellation-form-error {
  margin: 15px 0 0;
  color: #b42318;
  font-size: calc(13px + var(--kds-font-delta, 0px));
  font-weight: 550;
  line-height: 1.45;
}

.cancellation-review-footer {
  display: flex;
  flex: 0 0 auto;
  justify-content: flex-end;
  gap: 10px;
  padding: 15px 28px max(15px, env(safe-area-inset-bottom));
  border-top: 1px solid #e5eaf0;
  background: #fff;
}

.cancellation-secondary-btn {
  border: 1px solid #d7dee7;
  background: #fff;
  color: #48566a;
}

.cancellation-secondary-btn:hover:not(:disabled) {
  background: #f6f8fa;
}

.cancellation-confirm-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  border: 1px solid #ba3830;
  background: #b42318;
  color: #fff;
}

.cancellation-confirm-btn:hover:not(:disabled) {
  background: #991b14;
}

@media (max-width: 600px) {
  .cancellation-review-header {
    padding: 20px 56px 16px 20px;
  }

  .cancellation-review-body {
    padding: 18px 20px;
  }

  .cancellation-review-footer {
    padding-left: 20px;
    padding-right: 20px;
  }

  .cancellation-entry-btn {
    padding-left: 12px;
    padding-right: 12px;
  }
}

/* ===== Reject Confirmation Popup ===== */
.confirm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.confirm-box {
  background: #fff;
  border-radius: 8px;
  padding: 20px 25px;
  width: 320px;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
  animation: fadeIn 0.25s ease;
}

.confirm-box h4 {
  font-size: calc(16px + var(--kds-font-delta, 0px));
  font-weight: 600;
  color: #222;
  margin-bottom: 6px;
}

.confirm-box p {
  font-size: calc(13px + var(--kds-font-delta, 0px));
  color: #666;
  margin-bottom: 14px;
}

.confirm-actions {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.cancel-btn {
  background: white;
  border: 1px solid #ccc;
  color: #333;
  border-radius: 6px;
  padding: 6px 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.cancel-btn:hover {
  background: #f7f7f7;
}

.confirm-reject-btn {
  background: #ff3b30;
  border: none;
  color: white;
  border-radius: 6px;
  padding: 6px 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.confirm-reject-btn:hover {
  background: #e13228;
}

/* Additional styles for complimentary section enhancements */

.search-loading {
  padding: 10px;
  text-align: center;
  color: #666;
  font-size: calc(14px + var(--kds-font-delta, 0px));
}

.search-no-results {
  padding: 10px;
  text-align: center;
  color: #999;
  font-size: calc(14px + var(--kds-font-delta, 0px));
}

.search-dropdown-item {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  padding: 12px 16px;
  text-align: left;
  transition: all 0.2s ease;
  cursor: pointer;
  box-sizing: border-box;
}

.search-dropdown-item:hover:not(:disabled) {
  border-color: #cbd5e1;
  background-color: #f8fafc;
}

.search-dropdown-item:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.search-result-name {
  font-size: calc(15px + var(--kds-font-delta, 0px));
  font-weight: 500;
  color: #1e293b;
}

.search-result-add {
  font-size: calc(14px + var(--kds-font-delta, 0px));
  font-weight: 600;
  color: #2a71ff;
}

.out-of-stock-badge {
  padding: 4px 8px;
  background-color: #ffebee;
  color: #d32f2f;
  border-radius: 4px;
  font-size: calc(12px + var(--kds-font-delta, 0px));
  font-weight: 500;
}

.complimentary-items-list {
  margin-top: 16px;
  border-top: 1px solid #e0e0e0;
  padding-top: 12px;
}

.complimentary-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 7px;
  background-color: #f9f9f9;
  border-radius: 6px;
  margin-bottom: 8px;
}

.complimentary-item-name {
  flex: 1;
  font-size: calc(14px + var(--kds-font-delta, 0px));
  color: #333;
  font-weight: 500;
}

.complimentary-item-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.qty-btn-small {
  width: 28px;
  height: 28px;
  border: 1px solid #ddd;
  background-color: white;
  border-radius: 4px;
  cursor: pointer;
  font-size: calc(16px + var(--kds-font-delta, 0px));
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.qty-btn-small:hover {
  background-color: #f5f5f5;
  border-color: #999;
}

.qty-btn-small:active {
  background-color: #e0e0e0;
}

.qty-display-small {
  min-width: 30px;
  text-align: center;
  font-weight: 600;
  font-size: calc(14px + var(--kds-font-delta, 0px));
  color: #333;
}

.search-dropdown {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
  max-height: 250px;
  overflow-y: auto;
}

/* Gift icon styling for edit modal */
.edit-gift-icon {
  width: 16px;
  height: 16px;
  color: #2563eb;
  flex-shrink: 0;
  display: inline-block;
  vertical-align: middle;
}

.edit-item-label {
  display: flex;
  align-items: center;
  gap: 4px;
}

/* .removed-info {
  display: flex;
  align-items: center;
  gap: 4px;
} */
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/KDS/components/EditItem/editItem.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;EACE,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;EACT,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,gCAAgC;EAChC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,kDAAkD;EAClD,gBAAgB;EAChB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,YAAY;EACZ,OAAO;EACP,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,cAAc;EACd,yBAAyB;EACzB,yCAAyC;EACzC,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kDAAkD;EAClD,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kDAAkD;EAClD,gBAAgB;EAChB,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,kDAAkD;EAClD,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,yCAAyC;EACzC,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kDAAkD;EAClD,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,kDAAkD;EAClD,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kDAAkD;EAClD,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,kDAAkD;AACpD;;AAEA,2CAA2C;AAC3C;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kDAAkD;EAClD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kDAAkD;EAClD,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kDAAkD;EAClD,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kDAAkD;EAClD,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;EAC1B,YAAY;EACZ,kDAAkD;EAClD,yBAAyB;EACzB,yCAAyC;EACzC,sBAAsB;EACtB;;gCAE8B;AAChC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kDAAkD;EAClD,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,+BAA+B;AAC/B;EACE,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,6BAA6B;EAC7B,yDAAyD;EACzD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE;IACE,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;EAChC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE;IACE,mBAAmB;IACnB,mBAAmB;EACrB;AACF;;AAEA,mCAAmC;AACnC;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,kDAAkD;EAClD,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,yBAAyB;EACzB,cAAc;EACd,6BAA6B;EAC7B,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,4CAA4C;AAC5C;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA,6BAA6B;AAC7B;EACE,kDAAkD;EAClD,qBAAqB;EACrB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,UAAU;AACZ;AACA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;EACd,kDAAkD;AACpD;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;AACf;;AAEA;;;EAGE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kDAAkD;EAClD,gBAAgB;EAChB,eAAe;EACf,oFAAoF;AACtF;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;;EAGE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kDAAkD;EAClD,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kDAAkD;EAClD,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kDAAkD;EAClD,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kDAAkD;EAClD,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,SAAS;EACT,yDAAyD;EACzD,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA,0CAA0C;AAC1C;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kDAAkD;EAClD,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;;AAEA,6DAA6D;;AAE7D;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,kDAAkD;EAClD,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,kDAAkD;EAClD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kDAAkD;EAClD,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;;;GAIG","sourcesContent":["/* ===== Right-side edit drawer ===== */\n.edit-drawer-paper.MuiDrawer-paper {\n  width: min(620px, 100vw);\n  max-width: 100vw;\n  height: 100%;\n  max-height: none;\n  box-sizing: border-box;\n  overflow: hidden;\n  border: 0;\n  border-left: 1px solid #e2e8f0;\n  border-radius: 22px 0 0 22px;\n  background: #fff;\n  box-shadow: -20px 0 64px rgba(15, 23, 42, 0.18);\n}\n\n.edit-modal {\n  background: #fff;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  padding: 0;\n  position: relative;\n}\n\n.edit-modal-header {\n  flex: 0 0 auto;\n  padding: 24px 64px 20px 28px;\n  border-bottom: 1px solid #e2e8f0;\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.edit-title {\n  margin: 0;\n  font-size: calc(20px + var(--kds-font-delta, 0px));\n  font-weight: 650;\n  color: #0f172a;\n  letter-spacing: -0.015em;\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.close-btn {\n  position: absolute;\n  right: 16px;\n  top: 16px;\n  background: transparent;\n  border: none;\n  border-radius: 4px;\n  opacity: 0.7;\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n  color: #64748b;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px;\n}\n.close-btn:hover {\n  opacity: 1;\n  background: #f1f5f9;\n}\n.close-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n.edit-content {\n  padding: 24px 28px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.edit-drawer-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  padding-bottom: 22px;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.96);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* ===== Items List ===== */\n.edit-items-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.edit-item-container {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.edit-item-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  border-radius: 16px;\n  border: 1px solid #f1f5f9;\n  background-color: rgba(248, 250, 252, 0.7);\n  padding: 16px;\n}\n\n/* ===== Item Layout ===== */\n.edit-item-line {\n  display: flex;\n  min-width: 0;\n  flex: 1;\n  align-items: center;\n  gap: 12px;\n}\n\n.custom-checkbox {\n  display: grid;\n  place-content: center;\n  flex-shrink: 0;\n  border: 1px solid #cbd5e1;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  height: 20px;\n  width: 20px;\n  border-radius: 5px;\n  background: white;\n  cursor: pointer;\n  padding: 0;\n  color: transparent;\n  transition: all 0.2s;\n}\n\n.custom-checkbox[aria-checked=\"true\"] {\n  border-color: #2a71ff;\n  background-color: #2a71ff;\n  color: white;\n}\n\n.custom-checkbox svg {\n  height: 16px;\n  width: 16px;\n  pointer-events: none;\n}\n\n.edit-item-label-container {\n  min-width: 0;\n}\n\n.edit-item-name {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: calc(16px + var(--kds-font-delta, 0px));\n  font-weight: 500;\n  color: #1e293b;\n}\n\n.edit-item-name-complimentary {\n  background-color: #eff6ff;\n  color: #2a71ff;\n  border-radius: 50px;\n  padding: 4px 8px;\n  font-size: calc(10px + var(--kds-font-delta, 0px));\n  font-weight: 600;\n  margin-top: 4px;\n}\n\n/* ===== Quantity Buttons ===== */\n.edit-item-actions {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.qty-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n  font-weight: 500;\n  transition: all 0.2s ease;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  height: 36px;\n  width: 36px;\n  border-radius: 10px;\n  background-color: #ffffff;\n  color: #475569;\n  cursor: pointer;\n  padding: 0;\n}\n\n.qty-btn:hover:not(:disabled) {\n  background-color: #f8fafc;\n}\n\n.qty-btn:active:not(:disabled) {\n  box-shadow: none;\n}\n\n.qty-btn:disabled {\n  pointer-events: none;\n  opacity: 0.5;\n}\n\n.qty-btn svg {\n  width: 16px;\n  height: 16px;\n  pointer-events: none;\n}\n\n.qty-display {\n  width: 24px;\n  text-align: center;\n  font-size: calc(16px + var(--kds-font-delta, 0px));\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.original-qty {\n  text-decoration: line-through;\n  color: #94a3b8;\n  font-size: calc(13px + var(--kds-font-delta, 0px));\n  margin-left: 6px;\n  font-weight: 400;\n}\n\n/* ===== Notes and Addons ===== */\n.edit-item-note {\n  background: #ffeaea;\n  color: #b60000;\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: calc(13px + var(--kds-font-delta, 0px));\n  display: flex;\n  align-items: center;\n  margin: 0 0 0 44px;\n}\n\n.note-dot {\n  width: 6px;\n  height: 6px;\n  background: #ff3b30;\n  border-radius: 50%;\n  display: inline-block;\n  margin-right: 8px;\n}\n\n.edit-addons-container {\n  margin: 0 0 0 44px;\n  color: #64748b;\n  font-size: calc(13px + var(--kds-font-delta, 0px));\n}\n\n.edit-item-addon {\n  color: #64748b;\n  font-size: calc(13px + var(--kds-font-delta, 0px));\n}\n\n/* ===== Remover Section (Final UI) ===== */\n.remover-section {\n  background: #fef3f2;\n  border-radius: 8px;\n  padding: 10px 14px;\n  margin: 14px 28px 0;\n}\n.removed-item-title-logo {\n  display: flex;\n  gap: 6px;\n}\n.remover-title {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #d92d20;\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.removed-item-edit {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  padding: 4px 0;\n}\n\n.removed-info {\n  color: #444;\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n  text-decoration: line-through;\n  text-decoration-thickness: 1px;\n  text-decoration-color: #555;\n}\n\n.reset-link {\n  border: none;\n  background: transparent;\n  color: #007aff;\n  cursor: pointer;\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: color 0.2s ease;\n}\n\n.reset-link:hover {\n  color: #005ed1;\n}\n\n/* ===== Complimentary Section ===== */\n.complimentary-section {\n  margin-top: 18px;\n  padding: 0 28px;\n  margin-bottom: 10px;\n}\n\n.complimentary-label {\n  display: block;\n  margin-bottom: 8px;\n  font-size: calc(15px + var(--kds-font-delta, 0px));\n  font-weight: 600;\n  color: #334155;\n}\n\n.complimentary-search-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.complimentary-search-icon {\n  position: absolute;\n  left: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 16px;\n  height: 16px;\n  color: #94a3b8;\n  pointer-events: none;\n}\n\n.complimentary-search-input {\n  display: flex;\n  width: 100%;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 4px 12px 4px 44px;\n  height: 48px;\n  font-size: calc(15px + var(--kds-font-delta, 0px));\n  background-color: #ffffff;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  box-sizing: border-box;\n  transition:\n    border-color 0.15s ease-in-out,\n    box-shadow 0.15s ease-in-out;\n}\n\n.complimentary-search-input:focus {\n  outline: none;\n  border-color: #cbd5e1;\n  box-shadow: 0 0 0 1px #cbd5e1;\n}\n\n.complimentary-search-input::placeholder {\n  color: #94a3b8;\n}\n\n.complimentary-search-input:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.search-result {\n  padding: 6px 10px;\n  cursor: pointer;\n  font-size: calc(13px + var(--kds-font-delta, 0px));\n}\n\n.search-result:hover {\n  background: #f5f5f5;\n}\n\n.complimentary-item {\n  margin-top: 6px;\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n  color: #333;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.edit-item-name-container {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n/* ===== Footer Section ===== */\n.edit-footer {\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: column-reverse;\n  border-top: 1px solid #e2e8f0;\n  padding: 16px 28px max(16px, env(safe-area-inset-bottom));\n  gap: 12px;\n  background: #ffffff;\n}\n\n@media (min-width: 640px) {\n  .edit-footer {\n    flex-direction: row;\n    justify-content: flex-end;\n  }\n}\n\n.edit-footer-content {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  gap: 12px;\n}\n\n@media (min-width: 768px) {\n  .edit-footer-content {\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n  }\n}\n\n.edit-footer-right {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n@media (min-width: 768px) {\n  .edit-footer-right {\n    flex-direction: row;\n    align-items: center;\n  }\n}\n\n/* ===== Common Button Base ===== */\n.reject-btn,\n.update-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  transition: all 0.2s ease;\n  min-height: 36px;\n  padding: 8px 20px;\n  height: 48px;\n  border-radius: 20px;\n  font-size: calc(16px + var(--kds-font-delta, 0px));\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.reject-btn svg,\n.update-btn svg {\n  height: 16px;\n  width: 16px;\n  flex-shrink: 0;\n}\n\n/* ===== Reject (outlined red) ===== */\n.reject-btn {\n  border: 1px solid #fecdd3;\n  color: #e11d48;\n  background-color: transparent;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.reject-btn:hover {\n  border-color: #fda4af;\n  background-color: #fff1f2;\n  color: #be123c;\n}\n\n/* ===== Update Changes (solid blue) ===== */\n.update-btn {\n  border: 1px solid transparent;\n  background-color: #2a71ff;\n  color: #ffffff;\n}\n\n.update-btn:hover {\n  background-color: #1f63ea;\n}\n\n.update-btn:disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n/* ===== Icon Styling ===== */\n.btn-icon {\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n  display: inline-block;\n  line-height: 1;\n}\n\n/* ===== Scrollbar ===== */\n.edit-drawer-body::-webkit-scrollbar {\n  width: 6px;\n}\n.edit-drawer-body::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.15);\n  border-radius: 3px;\n}\n\n@media (max-width: 600px) {\n  .edit-drawer-paper.MuiDrawer-paper {\n    width: 100vw;\n    border-radius: 0;\n  }\n\n  .edit-modal-header {\n    padding: 20px 56px 18px 20px;\n  }\n\n  .edit-content {\n    padding: 18px 20px 0;\n  }\n\n  .remover-section {\n    margin-left: 20px;\n    margin-right: 20px;\n  }\n\n  .complimentary-section {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n\n  .edit-footer {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n}\n\n/* ===== Cancellation selection and review ===== */\n.edit-selection-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 0 0 16px;\n  border-bottom: 1px solid #e8edf3;\n  color: #657184;\n  font-size: calc(13px + var(--kds-font-delta, 0px));\n}\n\n.edit-selection-toolbar label,\n.cancellation-billing label {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  color: #334155;\n  font-weight: 550;\n}\n\n.edit-selection-toolbar input,\n.cancellation-review input[type=\"checkbox\"],\n.cancellation-review input[type=\"radio\"] {\n  width: 18px;\n  height: 18px;\n  margin: 0;\n  accent-color: #2563eb;\n  flex: 0 0 auto;\n}\n\n.edit-selection-toolbar label:has(input:disabled),\n.cancellation-billing label.is-disabled {\n  cursor: not-allowed;\n  opacity: 0.58;\n}\n\n.cancellation-entry-btn,\n.cancellation-confirm-btn,\n.cancellation-secondary-btn {\n  min-height: 42px;\n  border-radius: 10px;\n  padding: 10px 16px;\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n  font-weight: 650;\n  cursor: pointer;\n  transition: background-color 0.16s ease, border-color 0.16s ease, opacity 0.16s ease;\n}\n\n.cancellation-entry-btn {\n  flex: 0 0 auto;\n  border: 1px solid #f1b3b3;\n  background: #fff;\n  color: #b42318;\n}\n\n.cancellation-entry-btn:hover:not(:disabled) {\n  background: #fff5f4;\n  border-color: #e8918c;\n}\n\n.cancellation-entry-btn:disabled,\n.cancellation-confirm-btn:disabled,\n.cancellation-secondary-btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.52;\n}\n\n.cancellation-review {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  flex-direction: column;\n  background: #fff;\n}\n\n.cancellation-review-header {\n  position: relative;\n  flex: 0 0 auto;\n  padding: 26px 64px 20px 28px;\n  border-bottom: 1px solid #e5eaf0;\n}\n\n.cancellation-eyebrow {\n  margin: 0 0 7px;\n  color: #8a5360;\n  font-size: calc(10px + var(--kds-font-delta, 0px));\n  font-weight: 750;\n  letter-spacing: 0.13em;\n}\n\n.cancellation-subtitle {\n  margin: 7px 0 0;\n  color: #687587;\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n  line-height: 1.45;\n}\n\n.cancellation-close {\n  position: absolute;\n  top: 18px;\n  right: 18px;\n}\n\n.cancellation-review-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  padding: 22px 28px;\n}\n\n.cancellation-scope {\n  margin-bottom: 22px;\n  overflow: hidden;\n  border: 1px solid #e5eaf0;\n  border-radius: 13px;\n  background: #f8fafc;\n}\n\n.cancellation-scope-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 15px;\n  color: #445165;\n  font-size: calc(13px + var(--kds-font-delta, 0px));\n  font-weight: 650;\n}\n\n.cancellation-scope-heading strong {\n  display: grid;\n  width: 26px;\n  height: 26px;\n  place-items: center;\n  border-radius: 50%;\n  background: #e9eef5;\n  color: #364152;\n  font-size: calc(12px + var(--kds-font-delta, 0px));\n}\n\n.cancellation-item-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.cancellation-item-list li {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 11px 15px;\n  border-top: 1px solid #e9edf2;\n  color: #344054;\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n}\n\n.cancellation-item-list li strong {\n  flex: 0 0 auto;\n  color: #5b6676;\n}\n\n.cancellation-fieldset {\n  min-width: 0;\n  margin: 0 0 21px;\n  padding: 0;\n  border: 0;\n}\n\n.cancellation-fieldset legend {\n  margin-bottom: 10px;\n  color: #283548;\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n  font-weight: 700;\n}\n\n.cancellation-fieldset legend span {\n  color: #c03535;\n}\n\n.cancellation-fieldset select,\n.cancellation-fieldset textarea {\n  display: block;\n  width: 100%;\n  box-sizing: border-box;\n  border: 1px solid #d8e0e9;\n  border-radius: 10px;\n  background: #fff;\n  color: #273548;\n  font: inherit;\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n}\n\n.cancellation-fieldset select {\n  min-height: 46px;\n  padding: 0 13px;\n}\n\n.cancellation-fieldset textarea {\n  min-height: 82px;\n  margin-top: 10px;\n  padding: 12px 13px;\n  resize: vertical;\n}\n\n.cancellation-fieldset select:focus,\n.cancellation-fieldset textarea:focus {\n  outline: 2px solid rgba(37, 99, 235, 0.2);\n  border-color: #6e9beb;\n}\n\n.cancellation-choice-list {\n  display: grid;\n  gap: 9px;\n}\n\n.cancellation-choice-list label {\n  display: flex;\n  align-items: flex-start;\n  gap: 11px;\n  padding: 12px;\n  border: 1px solid #e0e6ed;\n  border-radius: 11px;\n  cursor: pointer;\n}\n\n.cancellation-choice-list label:has(input:checked) {\n  border-color: #8aabd9;\n  background: #f4f8ff;\n}\n\n.cancellation-choice-list label > span {\n  display: grid;\n  gap: 3px;\n  color: #334155;\n  font-size: calc(13px + var(--kds-font-delta, 0px));\n}\n\n.cancellation-choice-list small {\n  color: #697689;\n  font-size: calc(12px + var(--kds-font-delta, 0px));\n  line-height: 1.4;\n}\n\n.cancellation-note,\n.cancellation-billing > p {\n  margin: 8px 0 0;\n  color: #6b7788;\n  font-size: calc(12px + var(--kds-font-delta, 0px));\n  line-height: 1.5;\n}\n\n.cancellation-note {\n  padding: 11px 12px;\n  border-radius: 9px;\n  background: #f4f6f8;\n}\n\n.cancellation-billing {\n  padding: 15px;\n  border: 1px solid #e1e7ee;\n  border-radius: 12px;\n}\n\n.cancellation-billing label {\n  color: #344054;\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n}\n\n.cancellation-billing .cancellation-note {\n  margin-top: 10px;\n}\n\n.cancellation-refund-option {\n  margin-top: 13px;\n  min-height: 38px;\n  padding: 7px 12px;\n  border: 1px solid #d9e0e8;\n  border-radius: 8px;\n  background: #f6f7f9;\n  color: #687587;\n  font-size: calc(13px + var(--kds-font-delta, 0px));\n  font-weight: 600;\n  cursor: not-allowed;\n}\n\n.cancellation-context-state {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  padding: 18px 0;\n  color: #586679;\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n}\n\n.cancellation-context-state .MuiCircularProgress-root {\n  color: #2563eb;\n}\n\n.cancellation-context-error {\n  padding: 15px;\n  border: 1px solid #efc3bf;\n  border-radius: 11px;\n  background: #fff7f6;\n  color: #963a32;\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n  line-height: 1.5;\n}\n\n.cancellation-context-error p {\n  margin: 0 0 12px;\n}\n\n.cancellation-form-error {\n  margin: 15px 0 0;\n  color: #b42318;\n  font-size: calc(13px + var(--kds-font-delta, 0px));\n  font-weight: 550;\n  line-height: 1.45;\n}\n\n.cancellation-review-footer {\n  display: flex;\n  flex: 0 0 auto;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 15px 28px max(15px, env(safe-area-inset-bottom));\n  border-top: 1px solid #e5eaf0;\n  background: #fff;\n}\n\n.cancellation-secondary-btn {\n  border: 1px solid #d7dee7;\n  background: #fff;\n  color: #48566a;\n}\n\n.cancellation-secondary-btn:hover:not(:disabled) {\n  background: #f6f8fa;\n}\n\n.cancellation-confirm-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 9px;\n  border: 1px solid #ba3830;\n  background: #b42318;\n  color: #fff;\n}\n\n.cancellation-confirm-btn:hover:not(:disabled) {\n  background: #991b14;\n}\n\n@media (max-width: 600px) {\n  .cancellation-review-header {\n    padding: 20px 56px 16px 20px;\n  }\n\n  .cancellation-review-body {\n    padding: 18px 20px;\n  }\n\n  .cancellation-review-footer {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n\n  .cancellation-entry-btn {\n    padding-left: 12px;\n    padding-right: 12px;\n  }\n}\n\n/* ===== Reject Confirmation Popup ===== */\n.confirm-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.4);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.confirm-box {\n  background: #fff;\n  border-radius: 8px;\n  padding: 20px 25px;\n  width: 320px;\n  text-align: center;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);\n  animation: fadeIn 0.25s ease;\n}\n\n.confirm-box h4 {\n  font-size: calc(16px + var(--kds-font-delta, 0px));\n  font-weight: 600;\n  color: #222;\n  margin-bottom: 6px;\n}\n\n.confirm-box p {\n  font-size: calc(13px + var(--kds-font-delta, 0px));\n  color: #666;\n  margin-bottom: 14px;\n}\n\n.confirm-actions {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.cancel-btn {\n  background: white;\n  border: 1px solid #ccc;\n  color: #333;\n  border-radius: 6px;\n  padding: 6px 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.cancel-btn:hover {\n  background: #f7f7f7;\n}\n\n.confirm-reject-btn {\n  background: #ff3b30;\n  border: none;\n  color: white;\n  border-radius: 6px;\n  padding: 6px 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n.confirm-reject-btn:hover {\n  background: #e13228;\n}\n\n/* Additional styles for complimentary section enhancements */\n\n.search-loading {\n  padding: 10px;\n  text-align: center;\n  color: #666;\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n}\n\n.search-no-results {\n  padding: 10px;\n  text-align: center;\n  color: #999;\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n}\n\n.search-dropdown-item {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  padding: 12px 16px;\n  text-align: left;\n  transition: all 0.2s ease;\n  cursor: pointer;\n  box-sizing: border-box;\n}\n\n.search-dropdown-item:hover:not(:disabled) {\n  border-color: #cbd5e1;\n  background-color: #f8fafc;\n}\n\n.search-dropdown-item:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.search-result-name {\n  font-size: calc(15px + var(--kds-font-delta, 0px));\n  font-weight: 500;\n  color: #1e293b;\n}\n\n.search-result-add {\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n  font-weight: 600;\n  color: #2a71ff;\n}\n\n.out-of-stock-badge {\n  padding: 4px 8px;\n  background-color: #ffebee;\n  color: #d32f2f;\n  border-radius: 4px;\n  font-size: calc(12px + var(--kds-font-delta, 0px));\n  font-weight: 500;\n}\n\n.complimentary-items-list {\n  margin-top: 16px;\n  border-top: 1px solid #e0e0e0;\n  padding-top: 12px;\n}\n\n.complimentary-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 7px;\n  background-color: #f9f9f9;\n  border-radius: 6px;\n  margin-bottom: 8px;\n}\n\n.complimentary-item-name {\n  flex: 1;\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n  color: #333;\n  font-weight: 500;\n}\n\n.complimentary-item-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.qty-btn-small {\n  width: 28px;\n  height: 28px;\n  border: 1px solid #ddd;\n  background-color: white;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: calc(16px + var(--kds-font-delta, 0px));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.qty-btn-small:hover {\n  background-color: #f5f5f5;\n  border-color: #999;\n}\n\n.qty-btn-small:active {\n  background-color: #e0e0e0;\n}\n\n.qty-display-small {\n  min-width: 30px;\n  text-align: center;\n  font-weight: 600;\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n  color: #333;\n}\n\n.search-dropdown {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 8px;\n  max-height: 250px;\n  overflow-y: auto;\n}\n\n/* Gift icon styling for edit modal */\n.edit-gift-icon {\n  width: 16px;\n  height: 16px;\n  color: #2563eb;\n  flex-shrink: 0;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.edit-item-label {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n/* .removed-info {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n} */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
